import axios from "axios";

const BASE_URL = "https://backdanlu.eu-4.evennode.com";

// ✅ GET: Traer todos los clientes
export const getClientes = async () => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/clientes`;

  try {
    const resp = await axios.get(url, {
      headers: { token },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al obtener clientes",
    };
  }
};

// ✅ GET: Traer un cliente por ID
export const getClienteById = async (id) => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/clientes/${id}`;

  try {
    const resp = await axios.get(url, {
      headers: { token },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al obtener cliente",
    };
  }
};

// ✅ POST: Crear nuevo cliente
export const postCliente = async (clienteData) => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/clientes`;

  try {
    const resp = await axios.post(url, clienteData, {
      headers: {
        "Content-Type": "application/json",
        token,
      },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al crear cliente",
    };
  }
};

// ✅ PUT: Actualizar cliente
export const putCliente = async (id, clienteData) => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/clientes/${id}`;

  try {
    const resp = await axios.put(url, clienteData, {
      headers: {
        "Content-Type": "application/json",
        token,
      },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al actualizar cliente",
    };
  }
};

// ✅ DELETE: Desactivar cliente
export const deleteCliente = async (id) => {
  const token = localStorage.getItem("token") || "";

  const url = `${BASE_URL}/clientes/${id}`;

  try {
    const resp = await axios.delete(url, {
      headers: { token },
    });
    return resp.data;
  } catch (error) {
    return {
      ok: false,
      error: error.response?.data || "Error al eliminar cliente",
    };
  }
};
